<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <!-- <div class="row">
          <div class="jbl-field col-12">
            <datepicker :use-utc="false" class="jbl-dynamic-input" :typeable="true" name="cnic_expiry_date" v-model="dob" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
            <br>
            <span>YYYY-MM-DD - {{formattedDate}}</span>
            <br><br>
            <button @click="FormatDate()" class="">Test</button>
          </div>
          <div class="jbl-field col-12">
            <date-pick v-model="dob1" :format="'DD-MM-YYYY'" :displayFormat="'DD-MMM-YYYY'" :formatDate="formatDate2" :parseDate="parseDate"></date-pick>
            <span>YYYY-MM-DD - {{formattedDate1}}</span>
            <br><br>
            <button @click="FormatDate1()" class="">Test</button>
          </div>
        </div>
        <div class="row">
          <input type="file" accept="image/*" capture="camera" />
        </div> -->
      </div>


      <!-- RISK ACQUISITION -->
      <div class="container-fluid ib-acquisition-bg">
        <div class="container ib-p-0">
          <!-- Tab panes -->
          <div>
            <div class="container multistep-box">

              <!-- group rows -->
              <div class="row">
                <div class="col-12 mb-3">
                  <h1 class="ib-claim-listing" style="margin-top:0px !important;">How Do You Want To Provide Information?</h1>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-12 d-none d-md-block">
                    <table class="claim-listing">
                      <tbody>
                      <tr>
                        <td class="jbl-responsive-td complaint-td feedback-td">
                          <div class="complaint-td-first">
                            <img class="img-fluid" :src="require('@/assets/images/overall-feedback-2x.png')">
                          </div>
                        </td>
                        <td class="jbl-table-heading jbl-responsive-td feedback-text">
                          <div>Risk By Risk</div>
                          <!-- <div>Please Check Your Complaints</div> -->
                        </td>
                        <td class="jbl-responsive-td in-w-10">
                          <router-link :to="{ name: 'Overall'}" class="nex-Page-Link">
                            <!-- <i class="fa fa-chevron-right"></i> -->
                            <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                          </router-link>
                        </td>
                      </tr>
                      <tr>
                        <td class="jbl-responsive-td complaint-td feedback-td">
                          <div class="complaint-td-first">
                            <img class="img-fluid" :src="require('@/assets/images/policy-feedback-2x.png')">
                          </div>
                        </td>
                        <td class="jbl-table-heading jbl-responsive-td feedback-text">
                          <div>Tabular/Grid</div>
                          <!-- <div>Please Give Your Feedback</div> -->
                        </td>
                        <td class="jbl-responsive-td in-w-10">
                          <router-link :to="{ name: 'PoliciesFeedback' }" class="nex-Page-Link">
                            <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                            <!-- <i class="fa fa-chevron-right"></i> -->
                          </router-link>
                        </td>
                      </tr>
                      <tr>
                        <td class="jbl-responsive-td complaint-td feedback-td">
                          <div class="complaint-td-first">
                            <img class="img-fluid" :src="require('@/assets/images/claim-feedback-2x.png')">
                          </div>
                        </td>
                        <td class="jbl-table-heading jbl-responsive-td feedback-text">
                          <div>Spread Sheet Uploading</div>
                          <!-- <div>Please Give Your Feedback</div> -->
                        </td>
                        <td class="jbl-responsive-td in-w-10">
                          <router-link :to="{ name: 'ClaimsFeedback'}" class="nex-Page-Link">
                            <!-- <i class="fa fa-chevron-right"></i> -->
                            <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                          </router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- mobile view -->
                  <div class="col-md-12 d-md-none">
                    <div class="d-flex in-sm-listing ib-cursor-pointer">
                      <div class="in-sm-firstdiv">
                        <div class="in-listing-img in-sm-height">
                          <img class="img-fluid" style="width:64px;" :src="require('@/assets/images/overall-feedback-2x.png')"/>
                        </div>
                      </div>
                      <div class="in-sm-flex1">
                        <div class="in-sm-title">Overall Feedback</div>
                          <div class="d-flex">
                            <div class="in-sm-property">Please Give Your Feedback</div>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-12 d-md-none">
                    <div class="d-flex in-sm-listing ib-cursor-pointer">
                      <div class="in-sm-firstdiv">
                        <div class="in-listing-img in-sm-height">
                          <img class="img-fluid" style="width:64px;" :src="require('@/assets/images/policy-feedback-2x.png')"/>
                        </div>
                      </div>
                      <div class="in-sm-flex1">
                        <div class="in-sm-title">Policies</div>
                          <div class="d-flex">
                            <div class="in-sm-property">Please Give Your Feedback</div>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-12 d-md-none">
                    <div class="d-flex in-sm-listing ib-cursor-pointer">
                      <div class="in-sm-firstdiv">
                        <div class="in-listing-img in-sm-height">
                          <img class="img-fluid" style="width:64px;" :src="require('@/assets/images/claim-feedback-2x.png')"/>
                        </div>
                      </div>
                      <div class="in-sm-flex1">
                        <div class="in-sm-title">Claims</div>
                          <div class="d-flex">
                            <div class="in-sm-property">Please Give Your Feedback</div>
                          </div>
                        </div>
                    </div>
                  </div>
                  <!-- mobile view -->
                </div>
              <!-- group rows end here -->

              <!-- navtabs for individual and gruop -->
              <div class="row">
                <div class="col-md-12">
                  <div class="d2c-class-container mb-3 px-2 in-pt-77">
                    <ul class="nav nav-tabs ib-nav-tabs mx-auto ml-md-0" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link class-box in-horizontal-box">
                          <img alt="icon" :src="require('@/assets/images/flower-for-box.svg')"/>
                          <h4 class="class-name class-buy">Individual</h4>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link class-box in-horizontal-box">
                          <img alt="icon" :src="require('@/assets/images/flower-for-box.svg')"/>
                          <h4 class="class-name class-buy">Group</h4>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- navtabs for individual and gruop end here -->

              <!-- flower for box -->
              <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" />
              <!-- flower for box -->

              <!-- MultiStep Form -->
              <div class="container-fluid ib-p-0">
                <div class="row">
                  <div class="col-md-12">
                    <div class="main-form-div py-4">
                      <!-- flex-column -->
                      <div class="ib-form-nav">
                        <!-- <img class="img-fluid" v-if="nav_step == 1" :src="require('@/assets/images/acq-form-1.png')">
                        <img class="img-fluid" v-if="nav_step == 2" :src="require('@/assets/images/acq-form-2.png')"> -->
                        <img class="img-fluid" :src="require('@/assets/images/acq-form-3.png')">
                        <!-- <img class="img-fluid" v-if="nav_step == 4" :src="require('@/assets/images/acq-form-4.png')">
                        <img class="img-fluid" v-if="nav_step == 5" :src="require('@/assets/images/acq-form-5.png')"> -->
                      </div>
                      <hr class="ib-dotted-hr">
                      <div>
                        <div class="ib-totalcard-price">
                          <div class="d-md-flex align-items-md-center">
                            <div class="d-md-flex align-items-center" style="flex:1; padding: 1px; flex-flow:row wrap;">
                              <div class="ib-totalcard-img">
                                <img class="img-fluid" :src="require('@/assets/images/flower-for-box.svg')">
                              </div>
                              <div class="mr-2">
                                <div class="ib-total-company">Product company Name</div>
                                <div class="ib-total-plan">
                                  <span>Product Name</span>
                                  <div class="ib-card-plan">Plan Name</div>
                                </div>
                              </div>
                              <div>
                                <div class="ib-total-amount">Core Covers</div>
                                <div class="ib-total-rupees">Currency &amp; Price</div>
                              </div>
                              <div>
                                <div class="ib-total-amount">Addon's</div>
                                <div class="ib-total-rupees">
                                  Currency &amp; Price
                                </div>
                              </div>
                            </div>
                            <div class="ib-total-final">
                              <div class="ib-total-text in-min-start">
                                Total &nbsp;
                                <!-- <span class="discount-span">Currency &amp; Price</span> -->
                              </div>
                              <div class="ib-total-number">
                                Currency &amp; Price
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="multistep-box" style="padding: 2px !important; box-shadow: none !important;">
                        <div class="container">
                          <div class="row mb-0">
                          <div class="col-12 pt-3">
                            <ul class="list-inline mb-0">
                              <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing">Risk Listing</h1></li>
                              <form action="" class="float-md-right ml-md-auto list-position">
                                <li class="list-inline-item">
                                  <ul class="list-inline">
                                    <li class="list-inline-item">
                                      <div class="jbl-field in-search-field">
                                        <input type="text" id="texto" class="jbl-dynamic-input" placeholder="Search here...">
                                      </div>
                                    </li>
                                  </ul>
                                </li>
                                <li class="list-inline-item"><img class="img-fluid" alt="icon" :src="require('@/assets/images/in-risk-upload.svg')"></li>
                                <li class="list-inline-item"><img class="img-fluid" alt="icon" :src="require('@/assets/images/in-risk-download.svg')"></li>
                              </form>
                            </ul>
                          </div>
                        </div>
                        </div>
                        <div class="panel-group" id="accordion" style="padding-top:5px !important; padding-bottom:5px !important;" role="tablist" aria-multiselectable="true">
                        <div class="container">
                          <!-- First FAQ -->
                          <div class="panel panel-default">
                            <div class="panel-heading active" role="tab" id="headingOne">
                              <div class="collapsible-link">
                                <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                  01. Toyota Corrola 1.6 CVT
                                  <!-- <span class="Qmark">?</span> -->
                                  <span class="plus-icon">&plus;</span>
                                  <span class="minus-icon">&minus;</span>
                                </a>
                              </div>
                            </div>
                            <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                              <div class="panel-body">
                                <div class="container ib-border-b pb-3">
                                    <div class="row">
                                      <div class="col-md-6 px-0 px-sm-3">
                                        <div class="">
                                          <div class="">
                                            <div>
                                              <label>Engine No.<span>*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" type="text" placeholder="Enter Engine No.">
                                              </div>
                                              <!-- <div>
                                                <div>
                                                  <small class="text-danger">Error Message</small>
                                                </div>
                                              </div> -->
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6 px-0 px-sm-3">
                                        <div class="">
                                          <div class="">
                                            <div>
                                              <label>Engine No.<span>*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" type="text" placeholder="Enter Engine No.">
                                              </div>
                                              <!-- <div>
                                                <div>
                                                  <small class="text-danger">Error Message</small>
                                                </div>
                                              </div> -->
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6 px-0 px-sm-3">
                                        <div class="">
                                          <div class="">
                                            <div>
                                              <label>Engine No.<span>*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" type="text" placeholder="Enter Engine No.">
                                              </div>
                                              <!-- <div>
                                                <div>
                                                  <small class="text-danger">Error Message</small>
                                                </div>
                                              </div> -->
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6 px-0 px-sm-3">
                                        <div class="">
                                          <div class="">
                                            <div>
                                              <label>Engine No.<span>*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" type="text" placeholder="Enter Engine No.">
                                              </div>
                                              <!-- <div>
                                                <div>
                                                  <small class="text-danger">Error Message</small>
                                                </div>
                                              </div> -->
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>

                                <div class="container jbl-media-container ib-border-b pb-3 px-0">
                                  <h2 class="upload-title">Selected Addons</h2>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="ib-addon-card">
                                                <div class="d-flex mb-2 in-dir-col">
                                                    <div class="jbl-addon-media">
                                                        <h4 class="addon-card-title">Personal Accidnet</h4>
                                                    </div>
                                                    <div class="w-100 ib-btn-position">
                                                        <div class="float-right addon-btn-wh in-add-btn--fix"><span style="font-weight:bold;">Left : &nbsp;</span><span style="font-weight:bold; color: var(--primary-color);">99</span></div>
                                                        <!---->
                                                    </div>
                                                </div>
                                                <div class="d-flex in-dir-col">
                                                    <div>
                                                        <h6 class="addon-td-title">Cover Value:</h6>
                                                        <div class="d-flex w-100">
                                                            <h4 class="addon-td-desc">as per sum insured</h4>
                                                        </div>
                                                    </div>
                                                    <div class="pl-sm-5">
                                                        <h6 class="addon-td-title">Premium/Year</h6>
                                                        <div class="d-flex w-100">
                                                            <h4 class="addon-td-desc">PKR 100</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="addon-cover-desc">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Maxime enim molestiae qui nobis?</div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="ib-addon-card">
                                                <div class="d-flex mb-2 in-dir-col">
                                                    <div class="jbl-addon-media">
                                                        <h4 class="addon-card-title">Personal Accidnet</h4>
                                                    </div>
                                                    <div class="w-100 ib-btn-position">
                                                        <div class="float-right addon-btn-wh in-add-btn--fix"><span style="font-weight:bold;">Left : &nbsp;</span><span style="font-weight:bold; color: var(--primary-color);">100</span></div>
                                                        <!---->
                                                    </div>
                                                </div>
                                                <div class="d-flex in-dir-col">
                                                    <div>
                                                        <h6 class="addon-td-title">Cover Value:</h6>
                                                        <div class="d-flex w-100">
                                                            <h4 class="addon-td-desc">as per sum insured</h4>
                                                        </div>
                                                    </div>
                                                    <div class="pl-sm-5">
                                                        <h6 class="addon-td-title">Premium/Year</h6>
                                                        <div class="d-flex w-100">
                                                            <h4 class="addon-td-desc">PKR 100</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="addon-cover-desc">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Maxime enim molestiae qui nobis?</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="container mt-4">
                                  <h2 class="upload-title">Upload Images</h2>
                                  <div class="row pt-sm-4 py-sm-5">
                                    <div class="col-md-7 order-2 order-md-1 pt-4 pt-md-0">
                                      <div class="image-gallery">
                                        <div class="image-gallery-row">
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview" id="_front_right" :src="require('@/assets/images/flower-for-box.svg')" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'front_right').length > 0" class="mt-3 pl-2">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'front_right')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['front_center'][0]" -->
                                              <img class="img-fluid img-preview"  id="_front_center" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'front_center').length > 0" class="mt-3 pl-2">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'front_center')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['front_left'][0]" -->
                                              <img class="img-fluid img-preview"  id="_front_left" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'front_left').length > 0" class="mt-3 pl-2">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'front_left')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                        </div>
                                        <div class="image-gallery-row">
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['center_right'][0]" -->
                                              <img class="img-fluid img-preview" id="_center_right" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'center_right').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'center_right')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['center_top'][0]" -->
                                              <img class="img-fluid img-preview" id="_center_top" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'center_top').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'center_top')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['center_left'][0]" -->
                                              <img class="img-fluid img-preview" id="_center_left" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'center_left').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'center_left')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                        </div>
                                        <div class="image-gallery-row">
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['rear_right'][0]" -->
                                              <img class="img-fluid img-preview" id="_rear_right" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rear_right').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rear_right')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['rear_center'][0]" -->
                                              <img class="img-fluid img-preview" id="_rear_center" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rear_center').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rear_center')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                               <!-- :src="stepThreeMotorImagesPath['rear_left'][0]" -->
                                              <img class="img-fluid img-preview" id="_rear_left" alt="">
                                            </div>
                                            <!-- <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rear_left').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rear_left')[0].message}}</small>
                                              </div>
                                            </div> -->
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-5 order-1 order-md-2 mb-3">
                                      <div class="container mx-auto ib-car-bg">
                                        <div class="row">
                                          <div class="col-4">
                                            <div class="input-btn-width input-first-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'front_right')" onclick="this.value=null" -->
                                              <input id="front_right" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="front_right" class="css-label-checked" v-if="stepThreeMotorImages['front_right'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="front_right" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-second-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'front_center')" onclick="this.value=null" -->
                                              <input id="front_center" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="front_center" class="css-label-checked" v-if="stepThreeMotorImages['front_center'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="front_center" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-third-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'front_left')" onclick="this.value=null" -->
                                              <input  id="front_left" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="front_left" class="css-label-checked" v-if="stepThreeMotorImages['front_left'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="front_left" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-4">
                                            <div class="input-btn-width input-forth-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'center_right')" onclick="this.value=null" -->
                                              <input id="center_right" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="center_right" class="css-label-checked" v-if="stepThreeMotorImages['center_right'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="center_right" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-fifth-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'center_top')" onclick="this.value=null" -->
                                              <input id="center_top" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="center_top" class="css-label-checked" v-if="stepThreeMotorImages['center_top'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="center_top" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-sixth-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'center_left')" onclick="this.value=null" -->
                                              <input id="center_left" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="center_left" class="css-label-checked" v-if="stepThreeMotorImages['center_left'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="center_left" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-4">
                                            <div class="input-btn-width input-seventh-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'rear_right')" onclick="this.value=null" -->
                                              <input id="rear_right" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="rear_right" class="css-label-checked" v-if="stepThreeMotorImages['rear_right'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="rear_right" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-eighth-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'rear_center')" onclick="this.value=null" -->
                                              <input id="rear_center" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="rear_center" class="css-label-checked" v-if="stepThreeMotorImages['rear_center'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="rear_center" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-ninth-btn">
                                               <!-- @change="uploadStepThreeMotorImages($event, 'rear_left')" onclick="this.value=null" -->
                                              <input id="rear_left" type="file" accept="image/*" class="css-checkbox">
                                              <!-- <label for="rear_left" class="css-label-checked" v-if="stepThreeMotorImages['rear_left'].length > 0" style="font-size:20px !important;">&check;</label> -->
                                              <label for="rear_left" class="css-label">&#43;</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <!-- Second FAQ -->
                          <div class="panel panel-default">
                            <div class="panel-heading" role="tab" id="headingTwo">
                              <div class="collapsible-link">
                                <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                  02. Honda City 1.5 Aspire
                                  <!-- <span class="Qmark">?</span> -->
                                  <span class="plus-icon">&plus;</span>
                                  <span class="minus-icon">&minus;</span>
                                </a>
                              </div>
                            </div>
                            <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                              <div class="panel-body">
                                Insurance Bazaar removes all the hassles for you whether it is buying a policy, requesting policy servicing or filing a claim. It also provides a comparison of the best available plans and coverages in Pakistan.
                              </div>
                            </div>
                          </div>
                          <!-- Third FAQ -->
                          <div class="panel panel-default">
                            <div class="panel-heading" role="tab" id="headingThree">
                              <div class="collapsible-link">
                                <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                  03. Toyota Corrola 1.6 CVT
                                  <!-- <span class="Qmark">?</span> -->
                                  <span class="plus-icon">&plus;</span>
                                  <span class="minus-icon">&minus;</span>
                                </a>
                              </div>
                            </div>
                            <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                              <div class="panel-body">
                                At the moment we are offering the following products from different companies
                                <ul>
                                  <li>Life Insurance</li>
                                  <li>Motor Insurance</li>
                                  <li>Health Insurance</li>
                                  <li>Travel</li>
                                  <li>Personal Accident Insurance</li>
                                  <li>Home Insurance</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <!-- Fourth FAQ -->
                          <div class="panel panel-default">
                            <div class="panel-heading" role="tab" id="headingFour">
                              <div class="collapsible-link">
                                <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                  04. Honda City 1.5 Aspire
                                  <!-- <span class="Qmark">?</span> -->
                                  <span class="plus-icon">&plus;</span>
                                  <span class="minus-icon">&minus;</span>
                                </a>
                              </div>
                            </div>
                            <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
                              <div class="panel-body">
                                Your payment options are credit card and debit card at the moment.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>

                      <div class="ib-action-btns">
                        <button class="ib-btn-primary ib-btn-width ib-btn-hover">Continue</button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- RISK ACQUISITION END HERE -->
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import loading from '@/components/Loading/Loading';
  import moment from "moment";
  import DatePick from 'vue-date-pick';
  import 'vue-date-pick/dist/vueDatePick.css';
  import fecha from 'fecha';

  export default {
    name: 'test',
    data () {
      return {
        showLoader: false,
        formattedDate: '',
        formattedDate1: '',
        dob: '',
        dob1: '',
        focused: false
      }
    },
    components: {
      loading,
      Datepicker,
      DatePick
    },
    created () {
      document.addEventListener('visibilitychange', function(ev) {
        console.log(`Tab state : ${document.visibilityState}`);
      });

    },
    methods: {
      FormatDate() {
        const self = this;
        self.formattedDate = moment(self.dob).format('YYYY-MM-DD');
      },
      FormatDate1() {
        const self = this;
        self.formattedDate1 = moment(self.dob1, 'YYYY-MM-DD').format('YYYY-MM-DD');
      },
      formatDate2(dateObj, format) {
        return fecha.format(dateObj, format);
      },
      parseDate(dateString, format) {
        return fecha.parse(dateString, format);
      }
    }
  }
</script>

<style scoped>
  /* ul {
    list-style: none;
  }
  li {
    position: relative;
    color:  var(--text-color);
    font-family: "Avenir Book";
  }
  li:before {
    content: "•";
    position: absolute;
    left: -1em;
    color: var(--secondary-color);
  }
  .custom-number li:before {
    content: "";
    position: absolute;
    left: -1em;
  }
  .article-box p{
    font-family: "Avenir Book";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: var(--text-color);
  } */
.panel-default{
    /* background-color: rgba(249, 252, 253, 0.7); */
    margin-bottom: 18px;
  }
  .panel-body{
    font-family: "Avenir Book";
    font-size: 14px;
    text-align: left;
    color: #787b7c;
    padding: 15px;
  }
  .collapsible-link a{
    margin: 0 0 10px !important;
}
.legal-box-title{
  margin: 10px 0px;
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #ef7c94;
}
.legal-box-title span {
  color: #3d9cbd;
}

/* group rows CSS */
 .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 9px 0;
    padding: 10px;
    border-radius: 10px;
    border: solid 1px rgba(55, 141, 171, 0.25);
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
  }
  .position-relative .small-icon{
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 14px;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 84px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child {
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 0 0px 1px #d8eaf1;
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
    text-transform: capitalize;
  }
  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family: "Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  }
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  /* group rows CSS end here */
</style>



// WEBPACK FOOTER //
// src/views/Test.vue